// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2x2Lr","title":"Images90_title__lQXR-","images":"Images90_images__3lHXX"};